<template>
    <!-- <Head :title="title" /> -->
    <Head>
        <title>PessoalForm - Trabalho Temporário</title>
        <meta head-key="description" content="Na Pessoalform - Trabalho temporário centramos todos os nossos esforços na tentativa de dar ao cliente o exigido logo à primeira, mantendo elevados níveis de qualidade, indo, assim, ao encontro das suas necessidades e expectativas.">
        <meta head-key="keywords" content="Pessoalform, Trabalho temporário,temporary jobs, trabalho temporario, outsourcing, cedência de recursos humanos, formação , consultoria, e recrutamento e selecção permanente, trabalho, temporal, temporário, empresa, desemprego, procura emprego, emprego">
    </Head>
    <!-- Navbar -->
    <div class="block fixed top-0 left-0 w-full z-50 py-10 transition" id="header">
        <div class="container mx-auto px-4">

            <!-- auth -->
            <div class="flex justify-end space-x-4 relative -top-4 font-semibold">
                <a :href="route('jobs.index')" v-if="$page.props.user && $page.props.user.is_admin" class="flex justify-end items-center"><icon name="dashboard-2" class="h-4 w-4 mr-1" />  administração</a>
                <form @submit.prevent="logout" v-if="$page.props.user">
                    <button class="flex items-center font-semibold"><icon name="logout" class="h-4 w-4 mr-1" /> sair</button>
                </form>
                <a :href="route('login')" v-else class="no-print flex justify-end items-center"><icon name="login" class="h-4 w-4 mr-1" /> login</a>
            </div>
            
            <!-- navbar -->
            <navbar />
        </div>
    </div>
    <!-- main -->
    <main>
        <div class="fixed z-50 lg:top-60 right-0 left-0 lg:w-1/2 mx-auto p-10 bg-white border border-gray-100 shadow-lg text-center rounded-xl text-sm" v-show="cookieAlert == true">
            <p>Este website utiliza cookies para melhorar a sua experiência de navegação.</p>
            <p>Pode aceitar ou rejeitar os cookies, não constituindo a recusa limitação à navegação no website.</p>
            <p>Para saber mais sobre os cookies que usamos, consulte a nossa <a :href="route('pol_privacidade')" class="underline">Política de Privacidade</a>.</p>

            <div class="flex flex-row space-x-2 justify-center items-center mt-4">
                <button @click="rejectCookie" class="bg-violet-500 text-white py-1 px-4 rounded-full relative z-50" >Rejeitar</button>
                <button @click="setCookie" class="bg-violet-500 text-white py-1 px-4 rounded-full relative z-50" >Aceitar</button>
            </div>
        </div>
      
        <flash-messages />
        <slot></slot>
    </main>
    <newsletter/>
    <footer class="no-print text-sm leading-6 bg-primary-900 py-20 z-40 relative">
        <div class="container mx-auto px-4 text-white">
            <div class="md:flex py-4">
                <div class="md:w-1/3">
                        <h2 class="font-semibold">Menu</h2>
                        <ul class="mt-3 space-y-0 md:space-y-2">
                            <li>
                                <a class="transition hover:underline" :href="route('home')">Início</a>
                            </li>
                            <li>
                                <a class="transition hover:underline" :href="route('quem-somos')">Quem Somos</a>
                            </li>
                            <li>
                                <a class="transition hover:underline" :href="route('ofertas')">Ofertas de Emprego</a>
                            </li>
                            <li>
                                <a class="transition hover:underline" :href="route('empresas')">Para Empresas</a>
                            </li>
                            <li>
                                <a class="transition hover:underline" :href="route('candidatos')">Para Candidatos</a>
                            </li>
                            <li v-if="posts && posts.length > 0">
                                <a class="transition hover:underline" :href="route('posts')">Blogue</a>
                            </li>
                        </ul>
                </div>

                <div class="w-full md:w-1/3 mt-4 md:mt-0">
                        <h2 class="font-semibold">Informação</h2>
                        <ul class="mt-3 space-y-0 md:space-y-2">
                            <li>
                                <a class="transition hover:underline" :href="route('cod_conduta')">Código de Conduta</a>
                            </li>
                            <li>
                                <a class="transition hover:underline" :href="route('pol_privacidade')">Política de Privacidade</a>
                            </li>
                            <li>
                                <a class="transition hover:underline" :href="route('cond_utilizacao')">Condições de Utilização</a>
                            </li>
                            <li>
                                <a class="transition hover:underline" :href="route('faqs')">Perguntas Frequentes</a>
                            </li>
                             <li>
                                <a class="transition hover:underline" :href="route('contactos')">Contactos</a>
                            </li>
                        </ul>
                </div>

                <div class="flex-auto justify-end md:flex md:items-end mt-2">
                    <Link :href="route('home')">
                        <!-- <img src="/images/pessoalform_logo_white.svg" alt="pessoalform logo" class="h-6 md:h-12 w-auto" /> -->
                        <object data="/images/pessoalform_logo_white.svg" type="image/svg+xml" class="h-6 md:h-12 w-auto pointer-events-none"></object>
                       <!--  <jet-application-logo class="h-6 md:h-12 w-auto" /> -->
                    </Link>
                </div>
            </div>

            <div class="py-4">
                <div class="text-xs">    
                    <small class="block">&copy;{{year}} pessoalform.pt | desenvolvido por <a href="https://creativtools.com" target="_blank" class="hover:underline">creativtools</a></small>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import JetApplicationLogo from '@/Jetstream/ApplicationLogo.vue'
    import Icon from '@/Jetstream/Icon.vue'
    import Navbar from '@/Components/NavBar.vue'
    import FlashMessages from '@/Jetstream/FlashMessages'
    import Newsletter from '@/Components/Newsletter.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            JetApplicationLogo,
            Icon,
            Navbar,
            FlashMessages,
            Newsletter
        },
        props: {
            title: String,
            description: String,
        },
        data() {
            return {
                year: '',
                showMenu: false,
                cookieAlert: true,
                posts: ''
            }
        },
        created() {
            this.checkCookie()
            this.posts = this.$page.props.posts
            

            this.year = this.$page.props.year

            var scrollpos = window.scrollY;
            

            window.addEventListener("scroll", function() {

                var header = document.getElementById("header");

                scrollpos = window.scrollY;

                if(scrollpos > 0){
                    header.classList.add('bg-white', 'shadow-lg');
                }
                else {
                    header.classList.remove('bg-white', 'shadow-lg');
                }
            })
        },
        methods: {
            logout() {
                this.$inertia.post(route('logout'));
            },
            setCookie() {
                let expires = new Date();
                expires.setFullYear(expires.getFullYear() + 1); // Set cookie for 1 year
                document.cookie = `cookie=aceite; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`;
                this.cookieAlert = false; // Hide the alert
            },

            rejectCookie() {
                let expires = new Date();
                expires.setDate(expires.getDate() + 1); // Set cookie for 1 day
                document.cookie = `cookie=rejeito; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`;
                this.cookieAlert = false; // Hide the alert
            },

            checkCookie() {
                let cookies = document.cookie.split('; ').map(cookie => cookie.trim());
                if (cookies.some(item => item.startsWith('cookie=aceite')) || cookies.some(item => item.startsWith('cookie=rejeito'))) {
                    this.cookieAlert = false; // Hide alert if cookie exists
                } else {
                    this.cookieAlert = true; // Show alert if no cookie is set
                }
            }
        }
    })
</script>
